import React, { useState, useEffect } from 'react'
import { dateCol, strCol, numCol } from '@integec/grid-tools/lib/cols'
import CommonScreen from '../admin/component/CommonScreen'
import { connect } from 'react-redux'
import { Select, Button, Input } from 'antd'
import { getApiTargetInfo } from 'core/selectors'
import * as api from '../api/pgads'

const title = 'Message From Administration'

const AdminMessage = ({ apiTargetInfo }) => {
  const [insertEvent, setInsertEvent] = useState(false)
  const [categoryList, setCategoryList] = useState([])

  useEffect(() => {
    api
      .getMessageCategory(apiTargetInfo)
      .fork(console.log, data => setCategoryList(data))
  }, [apiTargetInfo])

  const insertComp = ({ insertData, setInsertData, onAdd, onCancel }) => (
    <div
      style={{
        width: '100%',
        display: 'flex',
      }}
    >
      <div
        style={{
          width: '100px',
          display: 'grid',
          alignContent: 'center',
          marginLeft: '20px',
        }}
      >
        Category :
      </div>
      <Select
        style={{ width: '200px' }}
        value={insertData.category}
        onChange={e => setInsertData({ ...insertData, category: e })}
      >
        {categoryList.map(({ category }) => (
          <Select.Option key={category}>{category}</Select.Option>
        ))}
      </Select>
      <div
        style={{
          width: '100px',
          display: 'grid',
          alignContent: 'center',
          marginLeft: '50px',
        }}
      >
        Message :
      </div>
      <Input
        style={{ width: '300px' }}
        value={insertData.message}
        onChange={e =>
          setInsertData({ ...insertData, message: e.target.value })
        }
        maxLength={15}
      />
      <Button
        type="primary"
        style={{ marginLeft: '50px' }}
        onClick={() => onAdd(true)}
      >
        Add
      </Button>
      <Button
        type="primary"
        style={{ marginLeft: '50px' }}
        onClick={() => onAdd(false)}
      >
        Add & Hide
      </Button>
      <Button type="danger" style={{ marginLeft: '50px' }} onClick={onCancel}>
        Cancel
      </Button>
    </div>
  )

  return (
    <CommonScreen
      withUnitSelection={false}
      isAdminScreen
      title={title}
      header={AdminMessageHeaders}
      saveTask={api.saveUserMessage}
      retrieveTask={api.getAdminMessage}
      deleteTask={api.deleteUserMessage}
      autoRetrieve
      sortOptions={AdminMessageHeaders}
      widthOffset={100}
      heightOffset={270}
      insertComp={insertEvent && insertComp}
      defaultInsertData={{ adminUser: true }}
      onInsertEvent={b => setInsertEvent(b)}
      insertCompHeight={0}
      autoFixColByKey={false}
      headerRowHeight={60}
      withUpdate={false}
      skipValidation
    />
  )
}

const mapStateToProps = state => ({
  apiTargetInfo: getApiTargetInfo(state),
})

export default connect(mapStateToProps)(AdminMessage)

export const AdminMessageHeaders = [
  dateCol({
    ident: 'datetime',
    display: 'Date Time',
    sortOrder: 'dsc',
  }),
  numCol({
    ident: 'messageId',
    display: 'Message ID',
    displayFormat: '0',
    isKey: true,
    alignment: 'right',
  }),
  dateCol({
    ident: 'ackDate',
    display: 'Acknowledged Date',
  }),
  strCol({
    ident: 'message',
    display: 'Message',
    width: 250,
    alignment: 'left',
  }),
]
